module.exports = __webpack_public_path__ + "static/media/error@2x.f0a8e82b.png";